export const config: ApplicationConfig = {
    production: true,
    environmentName: (<any>window)._env.environmentName,
    apiBaseUrl: (<any>window)._env.apiBaseUrl,
    identityBaseUrl: (<any>window)._env.identityBaseUrl,
    publicUrl: (<any>window)._env.publicUrl,
    version: '8a059cd-2026-10-22.084610',
  };
